import { apiFetch } from "./client.js";

export interface AuditLogEntry {
  id: number;
  entity: string;
  entityId: number | null;
  // Mirrors the audit_log `op` enum in apps/api/src/db/schema.ts. "read" was
  // missing here while the API was already writing it for vertraulich
  // document opens, so the type quietly disagreed with the rows.
  op: "create" | "update" | "delete" | "read";
  userId: number | null;
  at: number;
  beforeJson: string | null;
  afterJson: string | null;
}

interface ListResp { items: AuditLogEntry[]; total: number; page: number; pageSize: number; }

export const auditApi = {
  list: (params: {
    entity?: string; entityId?: number; op?: string;
    userId?: number; from?: number; to?: number;
    page?: number; pageSize?: number;
  } = {}): Promise<ListResp> => {
    const qs = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v !== undefined && v !== null) qs.set(k, String(v));
    }
    return apiFetch<ListResp>(`/api/audit${qs.toString() ? `?${qs}` : ""}`);
  },
};
